var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('InfoDetail',{attrs:{"infoGuid":"0bc2d387-9098-477b-8c0d-96b02d616aea"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }